import { Stack, Typography } from '@cast/design-system';

export const InventoryWorkloadListSavings = () => (
  <Stack gap={16}>
    <Typography variant="h4">Workload savings</Typography>
    <Typography variant="P14R" color="grey.400">
      Placeholder for workload-scoped savings list.
    </Typography>
  </Stack>
);
